import Request from '../../utilities/Request';

export const fetchReport = reportId =>
  Request.get(`/api/content/v1/reportbuilder/${reportId}`);

export const fetchChartPalette = (paletteId, paletteType) =>
  Request.get(`/api/brandkit/v1/chartColorPalettes?id=${paletteId}&type=${paletteType}`);

export const fetchDefaultTheme = () =>
  Request.get('/api/content/v1/dataapps/themes')
    .then(response => response.default[0]);
